import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import './index.css'
import clearshare_logo from '../img/clearshare_logo.png'
import banner_image from '../img/banner_image.jpg'

const Header = () => (
  <div
    style={{
      marginBottom: '2.45rem',
    }}
  >
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '1.45rem 1.0875rem',
      }}
    >
      <h1 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: '#000',
            textDecoration: 'none',
          }}
        >
          <img src={clearshare_logo} alt="Clearshare Logo" style={{
            marginBottom: 0
          }} />
        </Link>
      </h1>
    </div>
    <div className="hero" style={{
      height: '450px',
      width: '100%',
      boxShadow: '0 20px 40px rgba(0,0,0,.2)',
      backgroundImage: `url(${banner_image})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center'
    }}>
    </div>
  </div>
)

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Clearshare - Clarity in Timeshare"
      meta={[
        { name: 'description', content: 'Clearshare - Everything Timeshare - Coming Soon' },
        { name: 'keywords', content: 'clearshare, timeshares' },
      ]}
    />
    <Header />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 2.45rem',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js